import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../../../store/store";
import {
  requestDivisionOKRs,
  requestGetKRs,
  requestGetSubOKRs,
  requestGetTasks,
  requestPersonalOKRs,
} from "../common/request";
import {
  convertOKRsDivision,
  convertOKRsPersonal,
  mergeSubItemWithPrevOKRs,
} from "../helpers/convert";

const initialState = {
  okr: [],
  loading: false,
  status: "idle",
};

export const getPersonalOKRs = createAsyncThunk(
  "role/team-lead/personal/getOKRs",
  requestPersonalOKRs
);

export const getDivisionOKRs = createAsyncThunk(
  "role/team-lead/division/getOKRs",
  requestDivisionOKRs
);

export const getSubOKRs = createAsyncThunk(
  "role/team-lead/personal/getSubOKRs",
  requestGetSubOKRs
);

export const getKRs = createAsyncThunk(
  "role/team-lead/personal/getKRs",
  requestGetKRs
);

export const getTasks = createAsyncThunk(
  "role/team-lead/personal/getTasks",
  requestGetTasks
);

const teamLeadSlice = createSlice({
  name: "okr",
  initialState,
  reducers: {
    _onCleanUpOKRs(state) {
      state.okr = [];
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getPersonalOKRs.pending, (state) => {
        state.status = "loading";
        state.loading = true;
      })
      .addCase(getPersonalOKRs.fulfilled, (state, action) => {
        state.status = "success";
        state.okr = convertOKRsPersonal(action.payload);
        state.loading = false;
      })
      .addCase(getPersonalOKRs.rejected, (state) => {
        state.status = "failed";
        state.loading = false;
      })
      .addCase(getDivisionOKRs.pending, (state) => {
        state.status = "loading";
        state.loading = true;
      })
      .addCase(getDivisionOKRs.fulfilled, (state, action) => {
        state.status = "success";
        state.okr = convertOKRsDivision(action.payload);
        state.loading = false;
      })
      .addCase(getDivisionOKRs.rejected, (state) => {
        state.status = "failed";
        state.loading = false;
      })
      .addCase(getSubOKRs.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getSubOKRs.fulfilled, (state, action) => {
        state.status = "success";
        const payload: any = action.payload;
        state.okr = mergeSubItemWithPrevOKRs(
          {
            level: payload.level,
            parentId: payload.parentId,
            keyValue: payload.keyValue,
            response: payload.response.data,
            parentUUID: payload.parentUUID,
          },
          state.okr
        );
      })
      .addCase(getSubOKRs.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(getKRs.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getKRs.fulfilled, (state, action) => {
        state.status = "success";
        const payload: any = action.payload;
        state.okr = mergeSubItemWithPrevOKRs(
          {
            level: payload.level,
            parentId: payload.parentId,
            keyValue: payload.keyValue,
            response: payload.response.data,
            parentUUID: payload.parentUUID,
          },
          state.okr
        );
      })
      .addCase(getKRs.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(getTasks.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getTasks.fulfilled, (state, action) => {
        state.status = "success";
        const payload: any = action.payload;
        state.okr = mergeSubItemWithPrevOKRs(
          {
            level: payload.level,
            parentId: payload.parentId,
            keyValue: payload.keyValue,
            response: payload.response.data,
            parentUUID: payload.parentUUID,
          },
          state.okr
        );
      })
      .addCase(getTasks.rejected, (state) => {
        state.status = "failed";
      });
  },
});

export default teamLeadSlice.reducer;
export const { _onCleanUpOKRs } = teamLeadSlice.actions;
export const selectorOKRs = (state: RootState) => state.teamLead.okr;
export const selectorLoadingOKRs = (state: RootState) => state.teamLead.loading;
